<template>
  <div
    v-if="parsedSupplierEvents && parsedSupplierEvents.length > 0"
    class="min-h-[200px] mb-10"
  >
    <ProductShowcase
      :gtm-item-list-id="GtmItemListId.MagazineArticlePageSupplierClasses"
      :products="parsedSupplierEvents"
      :title="
        $t('magazine.articlePage.supplierEvents.sectionTitle', {
          partnerName: supplierGetters.getName(partnerData),
        })
      "
      :use-h-tag="false"
      class="mt-10"
      :algolia-insights-client="algoliaInsightsClient"
      algolia-insights-label="Magazine Article - Supplier Events"
    />
  </div>
</template>

<script setup lang="ts">
import type { Ref } from 'vue'
import type { EventDescription, Supplier } from '~/composables/types/event'
import { GtmItemListId } from '~/composables/useKftGtm/types'
import type { KftApiDefaultResponse } from '~/composables/types/kft-api'

const { client: algoliaInsightsClient } = useAlgoliaSearchInsights()

const partnerEvents = inject('partnerEvents') as Ref<
  KftApiDefaultResponse<EventDescription[]>
>
const partnerData = inject('partnerData') as Ref<Supplier>

const parsedSupplierEvents = computed(() => {
  return (
    partnerEvents.value?.data?.map((el) =>
      parseEventDescriptionToAlgoliaEventItem(el)
    ) || []
  )
})
</script>
